<template>
  <div class="record-chart">
    <div class="record-table">
      <vxe-grid
        border
        show-overflow
        resizable
        ref="loadCostChartRef"
        class="vxe-table-element"
        cell-class-name="multiple-select"
        size="mini"
        align="center"
        :auto-resize="true"
        :edit-config="canEdit ? {} : { trigger: 'click', mode: 'row' }"
        @edit-actived="editActivedEvent"
        :data="tableData"
        :edit-rules="tableRule"
        :toolbar="{}"
        :valid-config="{ autoPos: true, message: 'inline' }"
        height="300"
        @select-change="handleSelectionChange"
        @select-all="handleSelectionChange"
        :key="keyTime"
      >
        <template v-slot:buttons>
          <el-button size="small" type="primary" class="vxe-btn-primary">装卸费率行信息</el-button>
          <el-button
            @click="$refs.loadCostChartRef.commitProxy('insert_actived')"
            size="small"
            type="primary"
            class="vxe-btn-primary"
            v-if="showTableBtn"
            >新增</el-button
          >
          <el-button
            @click="deleteRowHandler"
            size="small"
            type="danger"
            class="vxe-btn-delete"
            v-if="showTableBtn"
            >删除</el-button
          >
        </template>
        <vxe-table-column type="checkbox" width="50" fixed="left"> </vxe-table-column>
        <vxe-table-column type="seq" title="序号" width="60"></vxe-table-column>
        <vxe-table-column
          v-for="(item, index) in columns"
          :key="index"
          :type="item.type"
          :fixed="item.fixed"
          :field="item.field"
          :title="item.title"
          :width="item.width"
          height="100%"
          :edit-render="item.editRender"
        >
          <template v-slot="{ row }">
            <span v-if="item.field == 'expenseCode'">{{
              getName('expenseCode', row[item.field])
            }}</span>
            <span v-else-if="item.field == 'isSpecialLibrary'">{{
              getName('isSpecialLibrary', row[item.field])
            }}</span>
            <span v-else-if="item.field == 'isContainer'">{{
              getName('isContainer', row[item.field])
            }}</span>
            <span v-else-if="item.field == 'isScattered'">{{
              getName('isScattered', row[item.field])
            }}</span>
            <span v-else-if="item.field == 'dedicatedLine'">{{
              getName('dedicatedLine', row[item.field])
            }}</span>
            <span v-else-if="item.field == 'commodityClassificationCode'">{{
              getName('commodityClassificationCode', row[item.field])
            }}</span>
            <span v-else-if="item.field == 'goodsTypeCode'">{{
              getName('commodityType', row[item.field])
            }}</span>
            <span v-else-if="item.field == 'goodsCategoryCode'">{{
              getName('commodityCategory', row[item.field])
            }}</span>
            <span v-else-if="item.field == 'pricingStandard'">{{
              getName('pricingStandard', row[item.field])
            }}</span>
            <span v-else-if="item.field == 'pricingUnit'">{{
              getName('pricingUnit', row[item.field])
            }}</span>
            <span v-else-if="item.field == 'documentCategories'">{{
              getName('documentCategories', row[item.field])
            }}</span>
            <span v-else-if="item.field == 'outboundType'">{{
              getName('outboundType', row[item.field])
            }}</span>
            <span v-else-if="item.field == 'reservoirType'">{{
              getName('reservoirType', row[item.field])
            }}</span>
            <span v-else-if="item.field == 'packagingCategory'">{{
              getName('packageCategoryName', row[item.field])
            }}</span>
            <span v-else-if="item.field == 'billingClassCode'">{{
              getName('billingClassCode', row[item.field])
            }}</span>
            <span v-else-if="item.field == 'specificationId'">
              {{ row['specificationCode'] }}
            </span>
            <span v-else-if="item.field == 'packId'">
              {{ row['packing'] }}
            </span>
            <span v-else>{{ row[item.field] }}</span>
          </template>
          <!--根据表格的tableColumnList显示在编辑状态下不同的控件-->
          <template v-slot:edit="{ row }">
            <el-input
              v-if="item.editRender.name == 'input'"
              :disabled="canEdit"
              v-model="row[item.field]"
            >
            </el-input>
            <el-select
              v-else-if="item.editRender.name == 'expenseCode'"
              filterable
              clearable
              :disabled="canEdit"
              v-model="row[item.field]"
              @change="(val) => expenseCodeChange(val, row)"
            >
              <el-option
                v-for="(i, index) in expenseList"
                :key="index"
                :label="i.label"
                :value="i.value"
              ></el-option>
            </el-select>
            <el-select
              v-else-if="item.editRender.name == 'commodityClassification'"
              filterable
              clearable
              :disabled="true"
              :value="commodityTypeCode"
            >
              <el-option
                v-for="(i, index) in commodityClassificationList"
                :key="index"
                :label="i.label"
                :value="i.value"
              ></el-option>
            </el-select>
            <el-select
              v-else-if="item.editRender.name == 'commodityType'"
              filterable
              clearable
              :disabled="canEdit"
              multiple
              v-model="row[item.field]"
              @change="(val) => goodsTypeChange(row, val)"
              style="width: 100%"
            >
              <el-option
                v-for="(i, index) in goodsTypeList"
                :key="index"
                :label="i?.label"
                :value="i?.value"
              ></el-option>
            </el-select>
            <el-select
              v-else-if="item.editRender.name == 'commodityCategory'"
              filterable
              clearable
              multiple
              :disabled="canEdit"
              v-model="row[item.field]"
              @change="(val) => commodityCategoryChange(val, row, item.field)"
            >
              <el-option
                v-for="(i, index) in goodsCategoryList"
                :key="index"
                :label="i.label"
                :value="i.value"
              ></el-option>
            </el-select>
            <el-select
              v-else-if="item.editRender.name == 'billingClassCode'"
              filterable
              clearable
              :disabled="canEdit"
              v-model="row[item.field]"
              @change="(val) => billingClassCodeChange(val, row, item.field)"
            >
              <el-option
                v-for="(i, index) in billingClassCodeList"
                :key="index"
                :label="i.label"
                :value="i.value"
              ></el-option>
            </el-select>
            <!-- <el-input
              v-else-if="item.editRender.name == 'commoditySpecifications'"
              disabled
              v-model="row[item.field]"
              style="width: 100%"
            >
            </el-input> -->
            <el-select
              v-else-if="item.editRender.name == 'commoditySpecifications'"
              :clearable="true"
              :filterable="true"
              :disabled="canEdit"
              multiple
              v-model="row[item.field]"
              @change="(val) => changecommoditySpecifications(val, row, '04')"
            >
              <el-option
                v-for="(i, index) in commoditySpecificationsList"
                :key="index"
                :label="i.name"
                :value="i.id"
              ></el-option>
            </el-select>
            <el-select
              v-else-if="item.editRender.name == 'pricingUnit'"
              filterable
              clearable
              :disabled="canEdit"
              v-model="row[item.field]"
            >
              <el-option
                v-for="(i, index) in pricingUnitOptions"
                :key="index"
                :label="i.label"
                :value="i.value"
              ></el-option>
            </el-select>
            <el-select
              v-else-if="item.editRender.name == 'pricingStandard'"
              filterable
              clearable
              :disabled="canEdit"
              v-model="row[item.field]"
              @change="(val) => pricingStandardChange(row, val)"
            >
              <el-option
                v-for="(i, index) in pricingStandardList"
                :key="index"
                :label="i.label"
                :value="i.value"
              ></el-option>
            </el-select>
            <el-select
              v-else-if="item.editRender.name == 'documentCategories'"
              filterable
              clearable
              :disabled="canEdit"
              v-model="row[item.field]"
            >
              <el-option
                v-for="(i, index) in documentCategoriesList"
                :key="index"
                :label="i.label"
                :value="i.value"
              ></el-option>
            </el-select>
            <el-select
              v-else-if="item.editRender.name == 'outboundType'"
              filterable
              clearable
              :disabled="canEdit"
              v-model="row[item.field]"
            >
              <el-option
                v-for="(i, index) in outboundTypeList"
                :key="index"
                :label="i.label"
                :value="i.value"
              ></el-option>
            </el-select>
            <el-select
              v-else-if="item.editRender.name == 'packId'"
              :clearable="true"
              :filterable="true"
              :disabled="canEdit"
              multiple
              v-model="row[item.field]"
              @change="(val) => changecommoditySpecifications(val, row, '05')"
            >
              <el-option
                v-for="(i, index) in packList"
                :key="index"
                :label="i.name"
                :value="i.id"
              ></el-option>
            </el-select>
            <el-select
              v-else-if="item.editRender.name == 'packageCategoryName'"
              :filterable="true"
              :clearable="true"
              :disabled="canEdit"
              v-model="row[item.field]"
            >
              <el-option
                v-for="(i, index) in packageCategoryNameList"
                :key="index"
                :label="i.label"
                :value="i.value"
              ></el-option>
            </el-select>
            <el-select
              v-else-if="item.editRender.name == 'isSpecialLibrary'"
              filterable
              clearable
              :disabled="canEdit"
              v-model="row[item.field]"
            >
              <el-option value="1" label="是"></el-option>
              <el-option value="0" label="否"></el-option>
            </el-select>
            <el-select
              v-else-if="item.editRender.name == 'dedicatedLine'"
              filterable
              clearable
              :disabled="canEdit"
              v-model="row[item.field]"
            >
              <el-option value="Y" label="是"></el-option>
              <el-option value="N" label="否"></el-option>
            </el-select>
            <el-select
              v-else-if="item.editRender.name == 'isScattered'"
              filterable
              clearable
              :disabled="canEdit"
              v-model="row[item.field]"
            >
              <el-option value="1" label="是"></el-option>
              <el-option value="0" label="否"></el-option>
            </el-select>
            <el-select
              v-else-if="item.editRender.name == 'reservoirType'"
              :filterable="true"
              :clearable="true"
              :disabled="canEdit"
              v-model="row[item.field]"
            >
              <el-option
                v-for="(i, index) in reservoirTypeList"
                :key="index"
                :label="i.label"
                :value="i.value"
              ></el-option>
            </el-select>
            <el-select
              v-else-if="item.editRender.name == 'isContainer'"
              filterable
              clearable
              :disabled="canEdit"
              v-model="row[item.field]"
            >
              <el-option value="1" label="是"></el-option>
              <el-option value="0" label="否"></el-option>
            </el-select>
            <search-table
              v-else-if="item.editRender.name == 'reservoirArea'"
              searchType="warehouse"
              :isMultiple="true"
              :extraData="{
                storageDepartmentCode: departmentCode,
                storageCompanyCode: companyCode,
              }"
              :disabled="canEdit"
              :currentValue="row.reservoirAreaName"
              @input="(val) => getWarehouse(val, row, item.field)"
            >
            </search-table>
            <el-input
              v-else-if="item.editRender.name == 'lowerTimeLimit'"
              :disabled="canEdit"
              v-model="row[item.field]"
              placeholder="请输入"
            >
            </el-input>
            <el-input
              v-else-if="item.editRender.name == 'upperTimeLimit'"
              :disabled="canEdit"
              v-model="row[item.field]"
              placeholder="请输入"
            >
            </el-input>
            <input-number-ad
              v-else-if="item.editRender.name == 'lowerWeightLimit'"
              v-model="row.lowerWeightLimit"
              :controls="false"
              :min="0"
              :max="999999999"
              :precision="0"
              :clearable="true"
              class="inputWidth"
              :disabled="canEdit"
              maxlength="10"
            ></input-number-ad>
            <input-number-ad
              v-else-if="item.editRender.name == 'upperWeightLimit'"
              v-model="row.upperWeightLimit"
              :controls="false"
              :min="0"
              :max="999999999"
              :precision="0"
              :clearable="true"
              class="inputWidth"
              :disabled="canEdit"
              maxlength="10"
            ></input-number-ad>
            <input-number-ad
              v-else-if="item.editRender.name == 'unitPrice'"
              v-model="row.unitPrice"
              :controls="false"
              :min="0"
              :max="999999999"
              :precision="4"
              :clearable="true"
              :disabled="canEdit"
              class="inputWidth"
              maxlength="10"
            ></input-number-ad>
          </template>
        </vxe-table-column>
      </vxe-grid>
    </div>
  </div>
</template>

<script>
  import { chartColumns } from './index.js';
  import inputNumberAd from '@/components/form-item/input-number-advance';
  import goodsMixins from '../../../mixins/goodsMixins';
  export default {
    name: 'LoadCostChart',
    mixins: [goodsMixins],
    props: {
      tableDataList: {
        type: Array,
        default: () => [],
      },
      showTableBtn: {
        type: Boolean,
        default: true,
      },
      isDisabled: {
        type: Boolean,
        default: true,
      },
      goodsType: {
        type: Array,
        default: () => [],
      },
      commodityTypeCode: {
        type: String,
        default: '',
      },
      goodsCategoryRow: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        tableTotal: 0,
        selectionList: [],
        tableData: [],
        columns: [],
        documentCategoriesList: [],
        outboundTypeList: [],
        pricingStandardList: [],
        pricingUnitList: [],
        pricingUnitOptions: [],
        goodsTypeList: [],
        goodsCategoryList: [],
        goodsCategoryAll: [],
        expenseList: [],
        reservoirTypeList: [], //库区类型
        packageCategoryNameList: [], //包装类别
        billingClassCodeList: [], //计费类别
        departmentCode: '',
        companyCode: '',
        ids: [],
        canEdit: false,
        disabledTimeLimit: true, //控制时间上下限能否编辑
        disabledWeightLimit: true, //控制重量上下限能否编辑
        tableRule: {
          // goodsTypeCode: [{ required: true, message: '商品类型必填', trigger: ['change', 'blur'] }],
          reservoirAreaName: [
            { required: true, message: '库区名称必填', trigger: ['change', 'blur'] },
          ],
          documentCategories: [
            { required: true, message: '单据类别必填', trigger: ['change', 'blur'] },
          ],
          pricingStandard: [
            { required: true, message: '计价标准必填', trigger: ['change', 'blur'] },
          ],
          pricingUnit: [{ required: true, message: '计价单位必填', trigger: ['change', 'blur'] }],
          unitPrice: [{ required: true, message: '单价必填', trigger: ['change', 'blur'] }],
        },
        keyTime: new Date().getTime(),
        commodityClassificationList: [],
        commodityClassificationName: '',
      };
    },
    mounted() {
      this.columns = chartColumns;
      this.pricingStandardList = this.dictListMap.warehousePricingStandard;
      this.pricingUnitList = this.dictListMap.warehousePricingUnit;
      this.pricingUnitOptions = this.pricingUnitList.filter((item) =>
        ['yuan_time', 'yuan_ton', 'yuan_ge', 'yuan_che'].includes(item.value)
      );
      this.documentCategoriesList = this.dictListMap.warehouseDocumentCategories;
      this.outboundTypeList = this.dictListMap.warehouseOutboundType;
      this.reservoirTypeList = this.dictListMap.warehouseContractWarehouseType;
      this.packageCategoryNameList = this.dictListMap.warehouseContractPackageType;
      // this.expenseList = this.dictListMap.warehouseContractLoadExpenseList;
      this.getExpenseListByCompanyName();
      this.billingClassCodeList = this.dictListMap.warehouseContractCountType;
      this.departmentCode = this.userInfo.departmentCode;
      this.companyCode = this.userInfo.companyCode;
    },
    methods: {
      // 新增行
      async newRowHandler() {
        this.$refs.dialogRef.openModal();
      },
      // 选中行
      handleSelectionChange({ selection }) {
        this.selectionList = selection;
      },
      // 删除处理事件
      deleteRowHandler() {
        if (!this.selectionList.length) {
          this.$message.error('请选择行操作');
          return;
        }
        const XIDList = this.selectionList.map((item) => item._XID);
        const idList = this.selectionList.map((item) => item.id).filter((item) => Boolean(item));
        this.ids = [...this.ids, ...idList];
        this.tableData = this.getTableData().filter((item) => !XIDList.includes(item._XID));
        this.selectionList = [];
      },
      // 货物类型切换时更新级联的下拉数据
      async goodsTypeChange(row, val) {
        console.log(row, val, 'row-val');
        let goodsTypeNameList = this.goodsTypeList.filter((item) => val.includes(item.value));
        row.commodityTypeId = goodsTypeNameList.map((item) => {
          return item.id;
        });
        row.goodsTypeName = goodsTypeNameList
          .map((item) => {
            return item.label;
          })
          ?.join(',');
        console.log(row.goodsTypeName, 'row.goodsTypeName');
        // row.commodityClassification =this.goodsTypeList.find(
        //   (item) => item.value == val
        // )?.typeName;
        // row.commodityClassificationCode = this.goodsTypeList.find(
        //   (item) => item.value == val
        // )?.typeCode;
        // let typeNameList = this.goodsTypeList.filter((item) => val.includes(item.value));
        // let typeCodeList = this.goodsTypeList.filter((item) => val.includes(item.value));
        // console.log(typeCodeList, 'typeCodeList');
        // typeNameList = typeNameList?.map((item) => {
        //   if (item.typeName) return item.typeName;
        // });
        // typeCodeList = typeCodeList?.map((item) => {
        //   if (item.typeCode) return item.typeCode;
        // });
        // row.commodityClassification = typeNameList.length ? typeNameList.join(',') : '';
        // row.commodityClassificationCode = typeCodeList.length ? typeCodeList.join(',') : '';
        row.goodsCategoryName = '';
        row.goodsCategoryCode = null;
        row.specificationCode = null;
        this.updateCategory(row);
      },
      // 货物品类选择时更新货物规格
      commodityCategoryChange(val, row) {
        console.log(val, row);
        // let itemList = [];
        // if(val?.length){
        //   val.map((val)=>{
        //     const item = this.goodsCategoryAll.find((item) => item.productDetailCode == val);
        //     itemList.push(item)
        //   })
        // }
        let itemList = this.goodsCategoryAll.filter((item) => val.includes(item.productDetailCode));
        let productChNameList = [];
        let detailProductModelList = [];
        let detailProductItemList = [];
        let packList = [];
        if (itemList?.length) {
          itemList.map((item) => {
            if (item.productChName) productChNameList.push(item.productChName);
            if (item.detailProductModelId) detailProductModelList.push(item);
            if (item.detailProductItems) detailProductItemList.push(item.detailProductItems);
            if (item.detailProductPacksId) packList.push(item);
          });
        }
        row['goodsCategoryName'] = productChNameList?.length ? productChNameList.join(',') : '';
        row['commoditySpecificationsList'] = detailProductModelList;
        row['packList'] = packList;
        row['detailProductItems'] = detailProductItemList?.length
          ? detailProductItemList.join(',')
          : '';
      },
      billingClassCodeChange(val, row) {
        const item = this.billingClassCodeList.find((item) => item.value == val);
        row['billingClass'] = item.label;
      },
      expenseCodeChange(val, row) {
        const item = this.expenseList.find((item) => item.value == val);
        row['expenseName'] = item.label;
      },
      // 根据选择的货物类型更新货物品类下拉
      updateCategory(row) {
        console.log('row', row.goodsTypeCode);
        const goodsType = row.goodsTypeCode;

        let itemList1 = [];
        if (goodsType?.length) {
          goodsType.map((goodsTypeItem) => {
            const item = this.goodsCategoryAll.filter(
              (item) => item.productParentCode == goodsTypeItem
            );
            itemList1.push(item);
          });
        }
        let itemList2 = [];
        if (itemList1.length) {
          itemList1.map((item) => {
            itemList2 = [...itemList2, ...item];
          });
        }

        // if (goodsType) {
        //   const item = this.goodsCategoryAll.filter((item) => item.productParentCode == goodsType);
        //   console.log("item",itemList2)
        if (itemList2.length !== 0) {
          this.goodsCategoryList = itemList2.map((item) => {
            return {
              ...item,
              value: item.productDetailCode,
              label: item.productChName,
            };
          });
          // }
        } else {
          this.goodsCategoryList = [];
        }
      },
      // 判断公司获取费用类型
      getExpenseListByCompanyName() {
        console.log(
          'this.dictListMap.warehouseContractGuizhongLoadExpenseList',
          this.dictListMap.warehouseContractGuizhongLoadExpenseList
        );
        if (this.userInfo.companyCode == 'OAC27' || this.userInfo.companyCode == 'OAC91') {
          this.expenseList = this.dictListMap.warehouseContractGuizhongLoadExpenseList;
        } else {
          this.expenseList = this.dictListMap.warehouseContractLoadExpenseList;
        }
      },
      // 表格行激活时处理函数
      editActivedEvent({ row }) {
        this.focusHandler(row, '04'); //规格
        this.focusHandler(row, '05'); //包装
        row.commodityClassificationCode = this.commodityTypeCode;
        row.commodityClassificationName = this.commodityClassificationName;
        this.updateCategory(row);
        if (row.billingClassCode == null || row.billingClassCode == undefined)
          row.billingClassCode = 'unfixed';
        //this.pricingUnitOptions = this.filterUtil(row.pricingStandard);
      },
      // 得到指定仓库
      getWarehouse(val, row, field) {
        row[field] = val ? val[0].storageName : null;
      },
      // 获取表格数据
      getValidateTableData() {
        return new Promise((resolve, reject) => {
          const $table = this.$refs.loadCostChartRef;
          const tableData = $table.getTableData().fullData;
          console.log(tableData, '表格数据');
          $table.validate((valid) => {
            console.log(tableData, '表格数据==', valid);
            if (valid) {
              const formTableData = tableData.map((item) => {
                return {
                  ...item,
                  departmentCode: this.userInfo.departmentCode,
                  departmentName: this.userInfo.departmentName,
                  companyCode: this.userInfo.companyCode,
                  companyName: this.userInfo.companyName,
                  parkCompany: this.userInfo.companyName,
                  parkCompanyCode: this.userInfo.companyCode,
                  businessDepartmentCode: this.userInfo.departmentCode,
                  goodsTypeCode: item.goodsTypeCode?.length ? item.goodsTypeCode.join(',') : '',
                  // goodsTypeName:item.goodsTypeName?.length?item.goodsTypeName.join(","):'',
                  goodsCategoryCode: item.goodsCategoryCode?.length
                    ? item.goodsCategoryCode.join(',')
                    : '',
                  commodityClassification: this.commodityClassificationList.find(
                    (item) => item.id == item.commodityClassificationcode
                  )?.label,
                  specificationId: item.specificationId?.length
                    ? item.specificationId.join(',')
                    : '',
                  packId: item.packId?.length ? item.packId.join(',') : '',
                };
              });
              resolve({ tableData: formTableData });
            } else {
              this.$message.error('请填写表格数据');
              reject({ tableData: [] });
            }
          });
        });
      },
      getTableData() {
        const $table = this.$refs.loadCostChartRef;
        return $table.getTableData().fullData;
      },
      // 替换显示表格中value为label
      getName(type, value) {
        // console.log('tupe-value', type, value, this.goodsTypeList);
        if (value == null || value == '') {
          return;
        }
        let item;
        if (type == 'commodityType') {
          if (!this.goodsTypeList.length) {
            return '';
          }
          item = this.goodsTypeList
            .filter((item) => value.includes(item?.value))
            .map((item) => {
              return item?.label;
            });
          return item?.length ? item.join(',') : '';
        } else if (type == 'commodityCategory') {
          if (!this.goodsCategoryAll.length) {
            return '';
          }
          item = this.goodsCategoryAll
            .filter((item) => value.includes(item.productDetailCode))
            .map((item) => {
              return item.productChName;
            });
          return item?.length ? item.join(',') : '';
          // item = this.goodsCategoryAll.find((item) => item.productDetailCode == value);
          // return item?.productChName;
        } else if (type == 'pricingStandard') {
          item = this.pricingStandardList.find((item) => item.value == value);
          return item?.label;
        } else if (type == 'pricingUnit') {
          item = this.pricingUnitList.find((item) => item.value == value);
          return item?.label;
        } else if (type == 'documentCategories') {
          item = this.documentCategoriesList.find((item) => item.value == value);
          return item?.label;
        } else if (type == 'outboundType') {
          item = this.outboundTypeList.find((item) => item.value == value);
          return item?.label;
        } else if (type == 'isSpecialLibrary') {
          item = [
            { value: 1, label: '是' },
            { value: 0, label: '否' },
          ].find((item) => item.value == value);
          return item?.label;
        } else if (type == 'isContainer') {
          item = [
            { value: 1, label: '是' },
            { value: 0, label: '否' },
          ].find((item) => item.value == value);
          return item?.label;
        } else if (type == 'isScattered') {
          item = [
            { value: 1, label: '是' },
            { value: 0, label: '否' },
          ].find((item) => item.value == value);
          return item?.label;
        } else if (type == 'dedicatedLine') {
          item = [
            { value: 'Y', label: '是' },
            { value: 'N', label: '否' },
          ].find((item) => item.value == value);
          return item?.label;
        } else if (type == 'reservoirType') {
          if (!this.reservoirTypeList.length) {
            return value;
          }
          item = this.reservoirTypeList.find((item) => item.value == value);
          return item?.label;
        } else if (type == 'packageCategoryName') {
          if (!this.packageCategoryNameList.length) {
            return value;
          }
          item = this.packageCategoryNameList.find((item) => item.value == value);
          return item?.label;
        } else if (type == 'billingClassCode') {
          if (!this.billingClassCodeList.length) {
            return value;
          }
          item = this.billingClassCodeList.find((item) => item.value == value);
          return item?.label;
        } else if (type == 'expenseCode') {
          if (!this.expenseList.length) {
            return value;
          }
          item = this.expenseList.find((item) => item.value == value);
          return item?.label;
        } else if (type == 'commodityClassificationCode') {
          if (!this.commodityClassificationList.length) {
            return value;
          }
          item = this.commodityClassificationList.find((item) => {
            return item.value == value;
          })?.label;
          return item;
        }
      },
      // 填充表格信息
      fullTableData(tableData) {
        this.tableData = tableData;
      },
      // 筛选计价单位
      // filterUtil(fieldValue) {
      //   if (fieldValue == 'time') {
      //     // 时间
      //     return this.pricingUnitList.filter((item) => ['yuan_time'].includes(item.value));
      //   } else if (fieldValue == '02') {
      //     // 一口价
      //     return this.pricingUnitList.filter((item) => ['14'].includes(item.value));
      //   } else if (fieldValue == '03') {
      //     // 重量
      //     return this.pricingUnitList.filter((item) => ['07', '08'].includes(item.value));
      //   } else if (fieldValue == '04') {
      //     // 数量
      //     return this.pricingUnitList.filter((item) => ['09', '10', '11'].includes(item.value));
      //   } else if (fieldValue == '05') {
      //     // 车次
      //     return this.pricingUnitList.filter((item) => ['12', '13'].includes(item.value));
      //   } else if (fieldValue == 'day') {
      //     // 按天数
      //     return this.pricingUnitList.filter((item) =>
      //       ['yuan_ton', 'yuan_ge', 'yuan_che'].includes(item.value)
      //     );
      //   }
      // },
      // 选择计价标准事件
      pricingStandardChange(row, val) {
        row.pricingUnit = null;
        row.lowerTimeLimit = null;
        row.upperTimeLimit = null;
        row.lowerWeightLimit = null;
        row.upperWeightLimit = null;
        if (val == 'time') {
          this.disabledWeightLimit = true;
          this.disabledTimeLimit = false;
        } else if (val == '03') {
          this.disabledTimeLimit = true;
          this.disabledWeightLimit = false;
        } else if (val == 'day') {
          this.disabledWeightLimit = true;
          this.disabledTimeLimit = false;
        } else {
          this.disabledWeightLimit = true;
          this.disabledTimeLimit = true;
        }
        // this.pricingUnitOptions = this.filterUtil(val);
      },

      // 表单商品类别变化时， 更改表格商品信息
      goodsTypeChage() {
        if (!this.canEdit && this.$refs.loadCostChartRef.getTableData().fullData.length) {
          const tableData = this.$refs.loadCostChartRef.getTableData().fullData;
          tableData.forEach((item) => {
            item.commodityTypeCode = null;
            item.commodityCategoryCode = null;
            item.commoditySpecifications = null;
            item.detailProductItems = null;
          });
          this.tableData = tableData;
        }
      },
      changecommoditySpecifications(val, row, attrType) {
        if (val.length) {
          if (attrType == '04') {
            let commoditySpecificationsList = [];
            this.commoditySpecificationsList.map((item) => {
              if (val.includes(item.id)) {
                commoditySpecificationsList.push(item.name);
              }
            });
            row.specificationCode = commoditySpecificationsList.join(',');
          } else {
            let packlist = [];
            packlist = this.packList
              .filter((item) => val.includes(item.id))
              ?.map((item) => {
                return item.name;
              });
            row.packing = packlist.join(',');
          }
        } else {
          row.specificationCode = '';
          row.packing = '';
        }
      },
    },
    comments: {
      inputNumberAd,
    },
    watch: {
      tableDataList: {
        handler(val) {
          if (val && Array.isArray(val) && val.length) {
            this.tableData = val.map((item) => {
              return {
                ...item,
                goodsTypeCode: item.goodsTypeCode ? item.goodsTypeCode.split(',') : [],
                // goodsTypeName:item.goodsTypeName?item.goodsTypeName.split(","):[],
                goodsCategoryCode: item.goodsCategoryCode ? item.goodsCategoryCode.split(',') : [],
                specificationId: item.specificationId?.length
                  ? item.specificationId.split(',')
                  : [],
                packId: item.packId?.length ? item.packId.split(',') : [],
              };
            });
          }
          console.log('重新赋值', this.tableData);
        },
        immediate: true,
        // deep: true,
      },
      // tableData: {
      //   handler(val) {
      //     if (val && Array.isArray(val) && val.length) {
      //       this.keyTime = new Date().getTime()
      //       this.fullTableData(val);
      //     }
      //   },
      //   immediate: true,
      //   deep: true,
      // },
      isDisabled: {
        handler(val) {
          if (this.$route.query?.pageMode !== 0) {
            this.canEdit = val;
          }
        },
        immediate: true,
      },
      goodsType: {
        handler(val) {
          console.log('goodsType', val);
          this.goodsTypeList = val;
        },
      },
      commodityTypeCode: {
        handler(val) {
          console.log('监听到商品类型变化', val);
          this.commodityClassificationName = this.commodityClassificationList.find(
            (item) => item.id == val
          )?.label;
          this.productCategoryId = this.commodityClassificationList.find(
            (item) => item.value == val
          )?.id;
        },
      },
    },
  };
</script>

<style lang="scss" scoped>
  .record-chart {
    background: #fff;

    .record-table {
      padding: 10px;
      box-sizing: border-box;
      padding-top: 0;
      ::v-deep .multiple-select {
        .vxe-cell {
          max-height: fit-content;
        }
      }
    }
  }
</style>
